class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
        setTimeout(checkCartItemCount, 500);
      });
      
    }
  }
  
  customElements.define('cart-remove-button', CartRemoveButton);
  
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement =
        document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
  
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);
  
      this.addEventListener('change', debouncedOnChange.bind(this));
    }
  
    cartUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      });
    }
  
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  
    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
      setTimeout(checkCartItemCount, 500);
    }
  
    onCartUpdate() {
      if (this.tagName === 'CART-DRAWER-ITEMS') {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('cart-items');
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
      setTimeout(checkCartItemCount, 500);
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents',
        },
      ];
    }
  
  updateQuantity(line, quantity, name, variantId) {
      this.enableLoading(line);
  
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
  
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');
  
          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
  
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
  
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);
  
          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
  
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        })
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }
  
    updateLiveRegions(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
      const cartStatus =
        document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
  
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.add('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  
    disableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems.classList.remove('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
  
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }
  
  customElements.define('cart-items', CartItems);
  
  if (!customElements.get('cart-note')) {
    customElements.define(
      'cart-note',
      class CartNote extends HTMLElement {
        constructor() {
          super();
  
          this.addEventListener(
            'change',
            debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
            }, ON_CHANGE_DEBOUNCE_TIMER)
          );
        }
      }
    );
  }
  
document.addEventListener('DOMContentLoaded', function() {
  // Event Listener für Änderungen an Checkboxes
  document.addEventListener('change', function(event) {
    var element = event.target;

    // Überprüfen, ob das geänderte Element eine Checkbox für Verkaufspläne ist
    if (element && element.type === 'checkbox' && element.id === 'sellingPlan') {
      var sellingPlanId = element.checked ? element.value : "";

      // Fetch cart data from cart.js endpoint
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          console.log('Cart Data:', cartData);

          // Prepare an array to store line items with updated selling plan
          var lineItems = [];
          var lineNumber = 0;
          // Loop through each item in the cart
         cartData.items.forEach(function(item) {
            // Add line item with updated selling plan to the lineItems array
            lineItems.push({
              line: lineNumber, // Using lineNumber as line number
              quantity: item.quantity,
              selling_plan: sellingPlanId
            });

            // Increment line number for next iteration
            lineNumber++;
          });

          console.log('Line Items:', lineItems);

          // Start updating line items
          updateLineItems(lineItems);
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }
  });
});
  
  

/* Schnelle Version Line Items Update 
  // Funktion zum Aktualisieren von Line Items
function updateLineItems(lineItems) {
   console.log('Array:', lineItems);
  // Überprüfen, ob lineItems vorhanden sind
  if (lineItems && lineItems.length > 0) {
    // Funktion zum rekursiven Aktualisieren von Line Items
    function updateLineItem(index) {
      // Überprüfen, ob currentIndex innerhalb des Arrays liegt
      if (index <= lineItems.length) {
        // Aktuellen Line Item aktualisieren
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(lineItems[index - 1]) // Index um 1 reduzieren, da wir bei 1 beginnen
        })
        .then(response => response.json())
        .then(json => {
          console.log('Response JSON:', json);
          // Nächsten Line Item aktualisieren
          updateLineItem(index + 1);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      } else {
        // Alle Line Items wurden aktualisiert, also updateLiveRegions aufrufen
        updateCart2();
      }
    }

    // Erstes Line Item aktualisieren
    updateLineItem(1); // Beginnen bei Index 1
  }
} */



// Funktion zum Deaktivieren des Buttons
function disableCheckoutButton() {
    document.getElementById('CartDrawer-Checkout').disabled = true;
}

// Funktion zum Aktivieren des Buttons
function enableCheckoutButton() {
    document.getElementById('CartDrawer-Checkout').disabled = false;
}

 function updateLineItems(lineItems) {
  disableCheckoutButton();
  console.log('Array:', lineItems);
  // Überprüfen, ob lineItems vorhanden sind
  if (lineItems && lineItems.length > 0) {
    // Funktion zum rekursiven Aktualisieren von Line Items
    function updateLineItem(index) {
      // Überprüfen, ob currentIndex innerhalb des Arrays liegt
      if (index < lineItems.length) {
        // Aktuellen Line Item aktualisieren
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            line: lineItems[index].line + 1, // Erhöhe die line-Nummer um 1
            quantity: lineItems[index].quantity,
            selling_plan: lineItems[index].selling_plan,
          })
        })
        .then(response => response.json())
        .then(json => {
          console.log('Request:', JSON.stringify({
            line: lineItems[index].line + 1,
            quantity: lineItems[index].quantity,
            selling_plan: lineItems[index].selling_plan
          }));
          console.log('Response JSON:', json);
          // Nächsten Line Item aktualisieren
          updateLineItem(index + 1);
        })
        .catch((error) => {
          console.error('Error:', error);
          // Continue with the next item even if there's an error
          updateLineItem(index + 1);
        });
      } else {
        // Alle Line Items wurden aktualisiert, also updateLiveRegions aufrufen
        updateCart2();
        enableCheckoutButton();
      }
    }

    // Erstes Line Item aktualisieren
    updateLineItem(0);
  }
}



function resetSellingPlanIds() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      console.log('Cart Data:', cartData);

      // Prepare an array to store line items with updated selling plan
      var lineItems = [];

      // Loop through each item in the cart
      cartData.items.forEach(function(item, index) {
        // Add line item with updated selling plan to the lineItems array
        lineItems.push({
          line: index, // Setze die line-Nummer direkt aus dem Index
          quantity: item.quantity,
          selling_plan: null
        });
      });

      console.log('Line Items:', lineItems);
      resetSelection();
      // Start updating line items
      updateLineItems(lineItems);
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}


  
  function updateCart2() {
    const tagName = 'CART-DRAWER-ITEMS';
  
  
    if (tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  
  
  
 /* // Funktion zum Aktualisieren der versteckten Eingabefelder
  function updateSellingPlanValues(selectedValue) {
      // Alle versteckten Eingabefelder mit derselben Klasse auswählen
      var sellingPlanValueFields = document.querySelectorAll('.sellingPlanValue');
      // Werte aller versteckten Eingabefelder aktualisieren
      sellingPlanValueFields.forEach(function(field) {
          field.value = selectedValue;
      });
  } */
  
  
  // Event-Listener für window.onload hinzufügen
 /* window.onload = function() {
      // Dropdown-Menü auswählen
      var sellingPlanDropdown = document.getElementById('sellingPlan');
  
      // Überprüfen, ob das Dropdown-Menü vorhanden ist
      if (sellingPlanDropdown) {
          // Event-Listener für Änderungen im Dropdown-Menü hinzufügen
          sellingPlanDropdown.addEventListener('change', function(event) {
              var selectedValue = event.target.value;
              // Ausgewählten Wert im Local Storage speichern
              localStorage.setItem('selectedSellingPlan', selectedValue);
              // Werte aller versteckten Eingabefelder aktualisieren
              updateSellingPlanValues(selectedValue);
          });
  
          // Überprüfen, ob ein gespeicherter Wert im Local Storage vorhanden ist
          var selectedSellingPlan = localStorage.getItem('selectedSellingPlan');
  
          // Wenn ein gespeicherter Wert vorhanden ist
          if (selectedSellingPlan) {
              // Setzen Sie ihn als ausgewählten Wert im Dropdown-Menü und in den versteckten Eingabefeldern
              sellingPlanDropdown.value = selectedSellingPlan;
              updateSellingPlanValues(selectedSellingPlan);
          } else {
              // Wenn kein Wert im Local Storage vorhanden ist, setzen Sie den Standardwert in den versteckten Eingabefeldern
              var defaultValue = sellingPlanDropdown.options[sellingPlanDropdown.selectedIndex].value;
              localStorage.setItem('selectedSellingPlan', defaultValue);
              updateSellingPlanValues(defaultValue);
          }
      }
  }; */

function checkCartItemCount() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const itemCount = data.item_count;
            console.log('Menge im Warenkorb:', itemCount);
            
            // Update the progress bar
            const progressBar = document.getElementById('progress-bar');
            let progressPercentage = (itemCount / 3) * 100;
            console.log('Fortschritt:', progressPercentage);
            
            // Ensure the progress percentage does not exceed 100%
            if (progressPercentage > 100) {
                progressPercentage = 100;
            }
            
            progressBar.style.width = `${progressPercentage}%`;
            console.log('Breite der Progressbar:', progressBar.style.width);

            // Update progress message
            const remainingItems = 3 - itemCount;
            const progressMessage = document.getElementById('progress-message');
            if (itemCount === 0 || itemCount === 1) {
                document.querySelector('.progress-bar').style.backgroundColor = '#b22f25';
                progressMessage.innerHTML = `Füge noch <strong>1</strong> leckeres Pasta Gericht hinzu.`;
                document.getElementById('cartdrop').style.display = 'none';
                checkCartForSellingPlan();
            } else if (itemCount === 2) {
                                document.querySelector('.progress-bar').style.backgroundColor = '#4caf50';
                                progressMessage.innerHTML = 'Super! Geh <a href="/checkout" style="background: #000; border-radius: 20px;padding: 5px;color: #fff;text-decoration: none;padding-left: 10px;padding-right: 10px;">zum Checkout</a> oder füge noch 1 Gericht hinzu und spare <strong>8 €</strong>.';
                                document.getElementById('cartdrop').style.display = 'none';
                                checkCartForSellingPlan();
            } else if (itemCount >= 3) {
                document.querySelector('.progress-bar').style.backgroundColor = '#4caf50';
                progressMessage.innerHTML = 'Gratuliere! Deine Pasta Box ist versandbereit & du sparst <strong>8 €</strong>.';
                document.getElementById('cartdrop').style.display = 'block';
            }
            
            // Show success message and activate cart drawer if needed
            if (itemCount >= 3) {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    cartDrawer.classList.add('active');
                    document.body.classList.add('overflow-hidden');
                    document.querySelector('.cartsuccessmsg').style.display = 'block';
                }
            } else {
                const cartDrawer = document.querySelector('cart-drawer');
                
            }

            // Show the fixed container if at least one item is in the cart
            const fixedContainer = document.getElementById('fixed-container');
            const toggleBtn = document.getElementById('toggle-btn');
            if (itemCount > 0) {
                fixedContainer.classList.remove('collapsed');
                toggleBtn.textContent = '−';
            } else {
                fixedContainer.classList.add('collapsed');
                toggleBtn.textContent = '+';
            }
        })
        .catch(error => {
            console.error('Fehler beim Abrufen der Warenkorbdaten:', error);
        });
}


// Initial check and setup an interval to periodically check
function updateProgressBar() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const itemCount = data.item_count;
            
            // Update the progress bar
            const progressBar = document.getElementById('progress-bar');
            let progressPercentage = (itemCount / 3) * 100;
            
            // Ensure the progress percentage does not exceed 100%
            if (progressPercentage > 100) {
                progressPercentage = 100;
            }
            
            progressBar.style.width = `${progressPercentage}%`;

            // Update progress message
            const remainingItems = 3 - itemCount;
            const progressMessage = document.getElementById('progress-message');

            if (itemCount === 0 || itemCount === 1) {
                progressMessage.innerHTML = `Füge noch <strong>1</strong> leckeres Pasta Gericht hinzu.`;
                document.getElementById('cartdrop').style.display = 'none';
                document.querySelector('.progress-bar').style.backgroundColor = '#b22f25';
                checkCartForSellingPlan();
            } else if (itemCount === 2) {
                progressMessage.innerHTML = 'Super! Geh <a href="/checkout" style="background: #000; border-radius: 20px;padding: 5px;color: #fff;text-decoration: none;padding-left: 10px;padding-right: 10px;">zum Checkout</a> oder füge noch 1 Gericht hinzu und spare <strong>8 €</strong>.';
                document.getElementById('cartdrop').style.display = 'none';
                document.querySelector('.progress-bar').style.backgroundColor = '#4caf50';
                checkCartForSellingPlan();
            } else if (itemCount >= 3) {
                progressMessage.innerHTML = 'Gratuliere! Deine Pasta Box ist versandbereit & du sparst 8 €.';
                document.getElementById('cartdrop').style.display = 'block';
                document.querySelector('.progress-bar').style.backgroundColor = '#4caf50';
            }
        })
        .catch(error => {
            console.error('Fehler beim Abrufen der Warenkorbdaten:', error);
        });
}


document.addEventListener('DOMContentLoaded', () => {
    const toggleBtn = document.getElementById('toggle-btn');
    const fixedContainer = document.getElementById('fixed-container');
    const progressMessage = document.getElementById('progress-message');

    toggleBtn.addEventListener('click', () => {
        fixedContainer.classList.toggle('collapsed');
        toggleBtn.textContent = fixedContainer.classList.contains('collapsed') ? '+' : '−';
    });
   updateProgressBar();
});




/* Drop Down wieder zurücksetzen */
function resetSelection() {
    var dropdown = document.getElementById("sellingPlan");
    dropdown.value = ""; // Setze den Wert auf leer, um "Einzelbestellung" auszuwählen
}

/*Selling Plan check if on page load */
window.onload = function() {
    fetch("/cart.js")
        .then(response => response.json())
        .then(data => {
            if (data && data.items) {
                for (let i = 0; i < data.items.length; i++) {
                    const item = data.items[i];
                    if (item.url && item.url.includes("selling_plan")) {
                        resetSellingPlanIds();
                        break;
                    }
                }
            }
        })
        .catch(error => console.error('Fehler beim Abrufen der Daten: ', error));
};

function checkCartForSellingPlan() {
    fetch("/cart.js")
        .then(response => response.json())
        .then(data => {
            if (data && data.items) {
                for (let i = 0; i < data.items.length; i++) {
                    const item = data.items[i];
                    if (item.url && item.url.includes("selling_plan")) {
                        resetSellingPlanIds();
                        break;
                    }
                }
            }
        })
        .catch(error => console.error('Fehler beim Abrufen der Daten: ', error));
}

       document.addEventListener('DOMContentLoaded', () => {
            const drawer = document.querySelector('.drawer');
            let touchstartX = 0;
            let touchendX = 0;
            const swipeThreshold = 60; // Schwellenwert für den Swipe in Pixeln

            function handleGesture() {
                if (touchendX > touchstartX && Math.abs(touchendX - touchstartX) > swipeThreshold) {
                    drawer.classList.remove('active');
                    document.body.classList.remove('overflow-hidden');
                }
            }

            drawer.addEventListener('touchstart', (e) => {
                touchstartX = e.changedTouches[0].clientX;
            });

            drawer.addEventListener('touchend', (e) => {
                touchendX = e.changedTouches[0].clientX;
                handleGesture();
            });

            // Optional: Unterstützung für Mausereignisse hinzufügen, falls gewünscht
            let mousedownX = 0;

            drawer.addEventListener('mousedown', (e) => {
                mousedownX = e.clientX;
            });

            drawer.addEventListener('mouseup', (e) => {
                const mouseupX = e.clientX;
                if (mouseupX > mousedownX && Math.abs(mouseupX - mousedownX) > swipeThreshold) {
                    drawer.classList.remove('active');
                    document.body.classList.remove('overflow-hidden');
                }
            });
        });


